module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "dedi"
  }, [_vm._v("O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THER TITLES IN THE CAMPAIGN CHRONICLES SERIES")])]), _vm._v(" "), _c('p', {
    staticClass: "dedi1"
  }, [_vm._v("Armada 1588"), _c('br'), _vm._v(" "), _c('i', [_vm._v("John Barratt")])]), _vm._v(" "), _c('p', {
    staticClass: "dedi1"
  }, [_vm._v("Napoleon’s Polish Gamble"), _c('br'), _vm._v(" Eylau and Friedland 1807"), _c('br'), _vm._v(" "), _c('i', [_vm._v("Christopher Summerville")])]), _vm._v(" "), _c('p', {
    staticClass: "dedi1"
  }, [_vm._v("Passchendaele"), _c('br'), _vm._v(" The Hollow Victory"), _c('br'), _vm._v(" "), _c('i', [_vm._v("Martin Marix Evans")])]), _vm._v(" "), _c('p', {
    staticClass: "dedi1"
  }, [_vm._v("Attack on the Somme"), _c('br'), _vm._v(" Haig’s Offensive 1916"), _c('br'), _vm._v(" "), _c('i', [_vm._v("Martin Pegler")])]), _vm._v(" "), _c('p', {
    staticClass: "dedi1"
  }, [_vm._v("Salerno 1943"), _c('br'), _vm._v(" The Invasion of Italy"), _c('br'), _vm._v(" "), _c('i', [_vm._v("Angus Konstam")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-268f31b9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/fm.vue
// module id = 60
// module chunks = 0